import axiosInstance from "../api/axiosInstance";

export const fetchDashboardStats = async () => {
    try {
        const response = await axiosInstance.get("/api/dashboard/stats");
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error fetching dashboard stats:", error);
        return { success: false, error: error.message };
    }
};
